import React, { useState } from "react";
import "@/App.css";
import { AnimatePresence } from "framer-motion";
import { Analytics } from "@vercel/analytics/react";
import { GameProvider, useGame } from "./context/GameContext";
import StartScreen from "./components/StartScreen";
import GameScreen from "./components/GameScreen";
import GameOverScreen from "./components/GameOverScreen";
import Leaderboard from "./components/Leaderboard";

const GameContent = () => {
  const { gameState } = useGame();
  const [showLeaderboard, setShowLeaderboard] = useState(false);

  if (showLeaderboard) {
    return <Leaderboard onBack={() => setShowLeaderboard(false)} />;
  }

  return (
    <AnimatePresence mode="wait">
      {gameState === 'start' && (
        <StartScreen 
          key="start"
          onShowLeaderboard={() => setShowLeaderboard(true)} 
        />
      )}
      {gameState === 'playing' && (
        <GameScreen key="playing" />
      )}
      {gameState === 'gameover' && (
        <GameOverScreen 
          key="gameover"
          onShowLeaderboard={() => setShowLeaderboard(true)} 
        />
      )}
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App min-h-screen" style={{ backgroundColor: '#FFFDF5' }}>
      <GameProvider>
        <GameContent />
      </GameProvider>
      <Analytics />
    </div>
  );
}

export default App;
